import React from 'react';

export default function IconSettingSubsribe() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0749 6.24086C14.0749 7.85086 12.7682 9.15752 11.1582 9.15752C9.54823 9.15752 8.24156 7.85086 8.24156 6.24086C8.24156 4.63085 9.54823 3.32419 11.1582 3.32419C12.7682 3.32419 14.0749 4.63085 14.0749 6.24086Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09323 8.30017L3.5749 13.8243"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.52567 12.8677L5.354 13.6961"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.76823 11.6309L6.59073 12.4534"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
